import { render, staticRenderFns } from "./CreateStripeFeesModal.vue?vue&type=template&id=3f8ae4e0"
import script from "./CreateStripeFeesModal.vue?vue&type=script&lang=js"
export * from "./CreateStripeFeesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports